import React from "react";
import { Link } from "react-router-dom";
import { Calculator, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import AracDiagram from "./dk-gelismis/AracDiagram";
import DkSablonBar from "./deger-kaybi-gelismis/DkSablonBar";
import HesapNetPanel from "./dk-gelismis/HesapNetPanel";
import { useDkGelismis } from "./deger-kaybi-gelismis/useDkGelismis";

/** Hızlı ön hesap — dosya bağlamı olmadan lead / bilgilendirme. */
export default function DkOnHesapPage() {
    const dk = useDkGelismis();

    return (
        <div className="min-h-screen bg-[#060a12] pb-16">
            <div className="border-b border-white/5 p-6 max-w-4xl mx-auto">
                <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-sky-500/10 border border-sky-500/25 text-[10px] uppercase tracking-wider text-sky-300 mb-3">
                    <Sparkles className="h-3 w-3" />
                    Ön hesap · bilgilendirme
                </div>
                <h1 className="font-display text-2xl text-white">Değer Kaybı Ön Hesap</h1>
                <p className="text-sm text-slate-500 mt-2 max-w-xl">
                    Plaka/dosya olmadan hızlı tahmin. Tam hesap, kayıt ve PDF için{" "}
                    <Link to="/yeni/deger-kaybi-gelismis" className="text-emerald-400 hover:underline">
                        gelişmiş merkez
                    </Link>
                    .
                </p>
            </div>

            <div className="p-6 max-w-4xl mx-auto space-y-6">
                <DkSablonBar sablonlar={dk.sablonlar} disabled={dk.loading} onApply={dk.uygulaSablon} />

                <div className="grid md:grid-cols-2 gap-6">
                    <AracDiagram
                        zones={dk.zones}
                        secili={dk.seciliParcalar}
                        onToggle={dk.parcaToggle}
                        disabled={dk.loading}
                        diagramMeta={dk.diagram}
                        gorunumler={dk.gorunumler}
                        aktifGorunum={dk.diagramGorunum}
                        onGorunumChange={dk.setDiagramGorunum}
                    />

                    <div className="space-y-3">
                        <Input
                            placeholder="Marka"
                            value={dk.marka}
                            onChange={(e) => dk.setMarka(e.target.value)}
                            className="bg-black/40 border-white/10"
                        />
                        <Input
                            placeholder="Model"
                            value={dk.model}
                            onChange={(e) => dk.setModel(e.target.value)}
                            className="bg-black/40 border-white/10"
                        />
                        <div className="grid grid-cols-2 gap-2">
                            <Input
                                placeholder="Yıl"
                                value={dk.modelYili}
                                onChange={(e) => dk.setModelYili(e.target.value)}
                                className="bg-black/40 border-white/10"
                            />
                            <Input
                                placeholder="KM"
                                value={dk.km}
                                onChange={(e) => dk.setKm(e.target.value)}
                                className="bg-black/40 border-white/10"
                            />
                        </div>
                        <Input
                            placeholder="Rayiç (₺)"
                            value={dk.rayic}
                            onChange={(e) => dk.setRayic(e.target.value)}
                            className="bg-black/40 border-white/10"
                        />
                        <Input
                            placeholder="Kusur %"
                            value={dk.kusur}
                            onChange={(e) => dk.setKusur(e.target.value)}
                            className="bg-black/40 border-white/10"
                        />
                        <Button
                            className="w-full bg-emerald-600 hover:bg-emerald-500"
                            disabled={dk.loading || !dk.rayic}
                            onClick={() => dk.hesapla(false)}
                        >
                            <Calculator className="h-4 w-4 mr-2" />
                            Hesapla
                        </Button>
                    </div>
                </div>

                {dk.hesap ? (
                    <div className="rounded-2xl border border-emerald-500/20 bg-emerald-500/5 p-4">
                        <HesapNetPanel hesap={dk.hesap} />
                        <p className="text-[10px] text-slate-600 mt-4">
                            Bu tutar ön bilgilendirmedir. Dosya açmak ve müvekkile iletmek için gelişmiş merkeze geçin.
                        </p>
                        <Link
                            to="/yeni/deger-kaybi-gelismis"
                            className="inline-block mt-3 text-sm text-emerald-400 hover:underline"
                        >
                            Tam hesaba geç →
                        </Link>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
